// Чистые помощники для панели слоёв.

// Новый массив с элементом, перемещённым с позиции from на to. Вход не мутируется.
export function moveItem(array, from, to) {
  const out = array.slice()
  const [item] = out.splice(from, 1)
  out.splice(to, 0, item)
  return out
}
